import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { RemoteGetTemplates } from 'data/usecases/remote-get-templates';
import { GetTemplates } from 'domain/usecases/get-templates';

export const makeRemoteGetTemplates = (): GetTemplates => {
  return new RemoteGetTemplates(makeApiUrl('/getTemplates'), makeAuthorizeHttpClientDecorator());
};
